var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRainbowCard = function SvgRainbowCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rainbow-card_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#rainbow-card_svg__b)",
    d: "M3.05.028a.84.84 0 0 1 .427 0h.073l1.084.21 8.387 1.123c.285.053.541.203.723.422a.95.95 0 0 1 .217.912l-2.097 14.392a1.2 1.2 0 0 1-.434.703 1.2 1.2 0 0 1-.65.21h-.145L.947 16.667a1.13 1.13 0 0 1-.716-.415 1.07 1.07 0 0 1-.224-.779l.289-1.896.579-3.089L2.248.94c.072-.27.223-.513.434-.702a.8.8 0 0 1 .368-.21m.151.771a.27.27 0 0 0-.158.07c-.072.07-.144.141-.144.211L.802 15.473c0 .14.073.35.29.35l9.688 1.335c.144 0 .217 0 .289-.07s.144-.14.144-.211L13.31 2.554c0-.14 0-.21-.072-.28s-.144-.14-.217-.14L3.333.799zm2.88 4.213a1.808 1.808 0 0 1 1.301.562c.072.07.216.14.289.07a2.52 2.52 0 0 1 1.446-.21c.525.147.974.482 1.256.938s.375.999.262 1.519c-.651 2.597-3.76 4.633-3.905 4.703a.278.278 0 0 1-.217.07.39.39 0 0 1-.289-.14c-.077-.077-2.24-2.601-2.313-5.125a2.58 2.58 0 0 1 .578-1.755c.2-.215.446-.383.721-.492.276-.11.573-.158.87-.14m-.146.632a1.205 1.205 0 0 0-.867.351c-.246.276-.398.62-.434.983-.144 1.966 1.374 4.142 1.952 4.844.796-.561 2.892-2.177 3.326-4.072.07-.352.006-.717-.18-1.027a1.52 1.52 0 0 0-.832-.658 1.3 1.3 0 0 0-1.012.21.74.74 0 0 1-.506.14.68.68 0 0 1-.435-.28 1.2 1.2 0 0 0-.412-.35 1.3 1.3 0 0 0-.528-.141z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rainbow-card_svg__b",
    x1: 0.093,
    x2: 16.675,
    y1: 18,
    y2: 14.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC80B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.327,
    stopColor: "#FF6260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#5F63BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B8A6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rainbow-card_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v18H0z"
  })))));
};
export default SvgRainbowCard;